import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ReactLink } from "@remix-run/react";
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { PlaySecondaryLink } from '../../../components/ClickableComponents/PlayLink';
import { PlayImage } from '../../../components/Image/PlayImage';
import { usePath } from '../../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowSectionDesktop = ({
  show,
  onClick
}) => {
  const {
    videoShowPath
  } = usePath();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(StyledShowSection, {
    children: [/*#__PURE__*/_jsx(ReactLink, {
      to: videoShowPath(show),
      children: /*#__PURE__*/_jsx(PlayImage, {
        aspectRatio: '16/9',
        src: show.imageUrl,
        width: 480,
        alt: show.title
      })
    }), /*#__PURE__*/_jsx(ShowLink, {
      text: t('videoDetailPage.showOverview', {
        showName: show.title,
        interpolation: {
          escapeValue: false
        }
      }),
      to: videoShowPath(show),
      onClick: onClick,
      expand: true,
      showDefaultIcon: true
    })]
  });
};
const StyledShowSection = styled.section.withConfig({
  displayName: "ShowSectionDesktop__StyledShowSection",
  componentId: "sc-16b7gk-0"
})(["flex-shrink:0;position:relative;display:none;border-left:1px solid ", ";", "{display:initial;padding-left:40px;width:320px;}", "{width:400px;}"], Colors.GREY_4a4a4a, Viewports.for('largeUp'), Viewports.for('xLargeUp'));
const ShowLink = styled(PlaySecondaryLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "ShowSectionDesktop__ShowLink",
  componentId: "sc-16b7gk-1"
})(["margin-top:16px;"]);